<div class="header">
  <a [attr.href]="eStockHomePage" class="header-logo ml-34px">
    <img src="assets/logo.png" alt="Logo" />
  </a>
  <div class="header-right">
      <p-dropdown #dd
        [options]="searchService.quickSearchResults"
        [(ngModel)]="searchService.searchTerm"
        placeholder="Пошук"
        [dropdownIcon]="'pi pi-search'"
        [showClear]="true"
        [editable]="true"
        emptyMessage="Нічого не знайдено"
        (ngModelChange)="onChange($event)"
        (onClick)="onSearchIconClick()"
                  (keyup.enter)="onSearchIconClick()"
      >
<!--      <ng-template let-group pTemplate="group">-->
<!--        <div class="flex align-items-center" *ngIf="!searchService.searchInProgress">-->
<!--          <img src="assets/icons/ic24-package.svg" *ngIf="group.label === 'Поставки'"/>-->
<!--          <med-icon-car size="24" *ngIf="group.label === 'Запаси'"></med-icon-car>-->
<!--          <med-icon-transaction size="24" *ngIf="group.label === 'Розподіли'"></med-icon-transaction>-->
<!--          <span>&nbsp;{{ group.label }}</span>-->
<!--        </div>-->
<!--        <div *ngIf="searchService.searchInProgress">>-->
<!--          Searching...-->
<!--        </div>-->
<!--      </ng-template>-->
    </p-dropdown>
      <med-btn skin="gray">
          <med-icon-notification size="16" (mouseenter)="notif.show($event)" (mouseleave)="notif.hide()"></med-icon-notification>
        <p-overlayPanel #notif>
          <div class="flex items-center h10-text">
             Сповіщення
          </div>
        </p-overlayPanel>
      </med-btn>
      <med-btn *ngIf="dataService.userRoleValue.getValue()==='MZU'" (click)="goToBasket()">
          Обране для розподілу &nbsp; {{basketService.basketItems.size}} &nbsp;
          <img src="assets/icons/ic24-drug-package.svg" />
      </med-btn>
      <div class="flex align-items-stretch flex-wrap" (click)="menu.toggle($event)" style="margin-right: 8px">
          <div class="flex align-items-center justify-content-center grid grid-nogutter left-dropdown">
              <div class="col-10">
                  <span class="top-lane" style="word-break: keep-all; white-space: nowrap;">{{accountService.fullName()}}</span>
                  <br>
                  <span class="bottom-lane" style="word-break: keep-all; white-space: nowrap;">
                      <span *ngIf="accountService.isDOZ()">ДОЗ</span>
                      <span *ngIf="accountService.isMZU()">МЗУ</span>
                      | {{accountService.organizationShortName()}}</span>
              </div>
              <div class="col-2">
                  <med-avatar [initials]="accountService.nameAbr()"></med-avatar>
              </div>
          </div>
      </div>
      <p-tieredMenu #menu [model]="items" [popup]="true"/>
  </div>
</div>
